module.exports = __webpack_public_path__ + "img/no_notifications.e3fd361b.svg";